import React from 'react';
import { EventIconWrapperProps } from './EventIconWrapperProps';

const EventIconWrapper: React.FC<EventIconWrapperProps> = (props) => {
  const { children, className, ...restProps } = props;
  return (
    <svg
      version="1.1"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      xmlSpace="preserve"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 28 28"
      width="28"
      height="28"
      {...restProps}
    >
      {children}
    </svg>
  );
};

export default EventIconWrapper;
